// GENERATED by scripts/build-category-lookup.mjs -- do not edit by hand.
// Normalised ingredient name (see itemIdentity.ts) -> grocery category, learned
// from the household's hand-entered recipes so URL-imported ingredients get a
// category instead of all landing in "other". 402 entries. To
// refresh, rerun the SQL documented at the top of the script and regenerate.
export const CATEGORY_LOOKUP: Record<string, string> = {
  "active dry yeast": "pantry",
  "allspice": "spices",
  "almond extract": "pantry",
  "almond flour": "bulk",
  "apple": "produce",
  "apple cider vinegar": "pantry",
  "apple juice": "pantry",
  "applesauce": "produce",
  "ascorbic acid powder": "pantry",
  "asparagus": "produce",
  "baby carrot": "produce",
  "baby spinach": "produce",
  "bacon": "protein",
  "bacon bit": "protein",
  "bacon grease": "protein",
  "baking powder": "pantry",
  "baking soda": "pantry",
  "balsamic vinegar": "pantry",
  "banana": "produce",
  "basil": "produce",
  "basmati rice": "bulk",
  "bay leaf": "spices",
  "beef broth": "pantry",
  "beef roast": "protein",
  "beet": "produce",
  "bell pepper": "produce",
  "bittersweet chocolate": "pantry",
  "black bean": "bulk",
  "black mustard seed": "spices",
  "black olive": "produce",
  "black pepper": "spices",
  "black peppercorn": "spices",
  "black sesame seed": "bulk",
  "black tea": "pantry",
  "blueberry": "produce",
  "boneless pork loin": "protein",
  "boneless pork shoulder": "protein",
  "bread flour": "bulk",
  "breadcrumb": "bulk",
  "broth": "pantry",
  "brown sugar": "pantry",
  "bulk pork sausage": "protein",
  "butter": "dairy",
  "butter flavoring": "pantry",
  "buttermilk": "dairy",
  "butternut squash": "produce",
  "butterscotch chip": "pantry",
  "cabbage": "produce",
  "cake mix": "pantry",
  "canning salt": "spices",
  "canola oil": "pantry",
  "caramel": "pantry",
  "cardamom": "spices",
  "cardamom pod": "spices",
  "carrot": "produce",
  "cayenne": "spices",
  "cayenne pepper": "spices",
  "celery": "produce",
  "celery seed": "spices",
  "cheddar cheese": "dairy",
  "cherry tomato": "produce",
  "chia seed": "bulk",
  "chicken breast": "protein",
  "chicken broth": "pantry",
  "chicken stock": "pantry",
  "chicken wing": "protein",
  "chickpea": "bulk",
  "chili flake": "spices",
  "chili powder": "spices",
  "chili sauce": "pantry",
  "chipotle tabasco sauce": "pantry",
  "chive": "produce",
  "chocolate chip": "pantry",
  "chopped pecan": "bulk",
  "chopped walnut": "bulk",
  "cider vinegar": "pantry",
  "cilantro": "produce",
  "cinnamon": "spices",
  "cinnamon stick": "spices",
  "clove": "spices",
  "coarse sea salt": "spices",
  "cocoa": "pantry",
  "cocoa powder": "pantry",
  "cold butter": "dairy",
  "cold milk": "dairy",
  "confectioners sugar": "pantry",
  "cooked rice": "bulk",
  "cool whip": "dairy",
  "coriander seed": "spices",
  "corn kernel": "produce",
  "corn syrup": "pantry",
  "cornmeal": "bulk",
  "cornstarch": "pantry",
  "couscous": "bulk",
  "crab apple": "produce",
  "cranberry": "produce",
  "cream cheese": "dairy",
  "cream of chicken soup": "pantry",
  "cream of tartar": "pantry",
  "creamy peanut butter": "pantry",
  "crushed red pepper": "spices",
  "crushed red pepper flake": "spices",
  "cucumber": "produce",
  "cumin": "spices",
  "cumin seed": "spices",
  "curry leaf": "produce",
  "curry powder": "spices",
  "dark brown sugar": "pantry",
  "dark chocolate chip": "pantry",
  "dark cocoa powder": "pantry",
  "date": "produce",
  "devils food cake mix": "pantry",
  "diced green chili pepper": "pantry",
  "diced green chily": "pantry",
  "diced mild green chily": "pantry",
  "diced tomato": "pantry",
  "dijon mustard": "pantry",
  "dill": "produce",
  "distilled white vinegar": "pantry",
  "dried basil": "spices",
  "dried cilantro": "spices",
  "dried marjoram": "spices",
  "dried oregano": "spices",
  "dried red pepper": "produce",
  "dried rosemary": "spices",
  "dried rosemary leaf": "spices",
  "dried thyme": "spices",
  "dried thyme leaf": "spices",
  "dry milk": "dairy",
  "dry mustard": "spices",
  "dry white wine": "pantry",
  "egg": "protein",
  "egg white": "protein",
  "egg yolk": "protein",
  "eggplant": "produce",
  "evaporated milk": "dairy",
  "extra virgin olive oil": "pantry",
  "fennel seed": "spices",
  "fish sauce": "pantry",
  "flaky sea salt": "spices",
  "food coloring": "pantry",
  "fresh basil": "produce",
  "fresh basil leaf": "produce",
  "fresh cilantro": "produce",
  "fresh coriander": "produce",
  "fresh cranberry": "produce",
  "fresh dill": "produce",
  "fresh dill weed": "produce",
  "fresh ginger": "produce",
  "fresh italian flat leaf parsley": "produce",
  "fresh lemon juice": "produce",
  "fresh mint": "produce",
  "fresh mushroom": "produce",
  "fresh orange peel": "produce",
  "fresh oregano": "produce",
  "fresh parsley": "produce",
  "fresh peach": "produce",
  "fresh rosemary": "produce",
  "fresh sage leaf": "produce",
  "fresh thyme": "produce",
  "fresh thyme leaf": "produce",
  "frozen corn": "frozen",
  "frozen whipped topping": "dairy",
  "garlic": "produce",
  "garlic clove": "produce",
  "garlic powder": "spices",
  "ghee": "dairy",
  "ginger": "produce",
  "gochujang": "pantry",
  "goose": "protein",
  "granulated sugar": "pantry",
  "grape leaf": "produce",
  "grated coconut": "produce",
  "grated lemon peel": "produce",
  "grated lime peel": "produce",
  "grated orange rind": "produce",
  "grated orange zest": "produce",
  "greek yogurt": "dairy",
  "green bell pepper": "produce",
  "green chily": "produce",
  "green onion": "produce",
  "green pea": "produce",
  "green pepper": "produce",
  "green tea": "pantry",
  "green tomato": "produce",
  "ground allspice": "spices",
  "ground beef": "protein",
  "ground black pepper": "spices",
  "ground cardamom": "spices",
  "ground cinnamon": "spices",
  "ground clove": "spices",
  "ground coriander": "spices",
  "ground cumin": "spices",
  "ground ginger": "spices",
  "ground ginger powder": "spices",
  "ground mustard": "spices",
  "ground nutmeg": "spices",
  "ground turkey": "protein",
  "ground turmeric": "spices",
  "half and half": "dairy",
  "hamburger": "protein",
  "heavy cream": "dairy",
  "heavy whipping cream": "dairy",
  "honey": "pantry",
  "hot sauce": "pantry",
  "instant yeast": "pantry",
  "jalapeno pepper": "produce",
  "kale": "produce",
  "ketchup": "pantry",
  "kosher salt": "spices",
  "lean ground beef": "protein",
  "lemon": "produce",
  "lemon curd": "pantry",
  "lemon extract": "pantry",
  "lemon juice": "produce",
  "lemon zest": "produce",
  "light brown sugar": "pantry",
  "light corn syrup": "pantry",
  "light soy sauce": "pantry",
  "lime": "produce",
  "lime juice": "produce",
  "liquid fruit pectin": "pantry",
  "long grain rice": "bulk",
  "mace": "spices",
  "maple syrup": "pantry",
  "maraschino cherry": "produce",
  "maraschino cherry juice": "pantry",
  "marble cake mix": "pantry",
  "mascarpone cheese": "dairy",
  "mayonnaise": "pantry",
  "melted butter": "dairy",
  "milk": "dairy",
  "mint leaf": "produce",
  "mixed green": "produce",
  "mixed vegetable": "produce",
  "molass": "pantry",
  "mozzarella cheese": "dairy",
  "mustard": "pantry",
  "mustard seed": "spices",
  "navy bean": "pantry",
  "new potato": "produce",
  "nutella": "pantry",
  "nutmeg": "spices",
  "nutritional yeast flake": "pantry",
  "oatmeal": "bulk",
  "oil": "pantry",
  "old fashioned oat": "bulk",
  "olive oil": "pantry",
  "onion": "produce",
  "onion powder": "spices",
  "orange": "produce",
  "orange extract": "pantry",
  "orange juice": "produce",
  "orange marmalade": "pantry",
  "orange peel": "produce",
  "orange zest": "produce",
  "oreo cookie crumb": "pantry",
  "oyster sauce": "pantry",
  "paprika": "spices",
  "parmesan": "dairy",
  "parmesan cheese": "dairy",
  "parmigiano reggiano": "dairy",
  "parsley": "produce",
  "parsnip": "produce",
  "pasta dough": "bulk",
  "peanut butter": "pantry",
  "pear": "produce",
  "pear juice": "produce",
  "pecan": "bulk",
  "pecan half": "bulk",
  "pecorino cheese": "dairy",
  "pepper": "spices",
  "peppercorn": "spices",
  "pickling cucumber": "produce",
  "pickling lime": "pantry",
  "pickling salt": "spices",
  "pickling spice": "spices",
  "pie crust": "bulk",
  "pie shell pastry": "bulk",
  "pimento": "produce",
  "pine nut": "pantry",
  "pistachio butter": "pantry",
  "popped corn": "bulk",
  "poppy seed": "spices",
  "potato": "produce",
  "powdered sugar": "pantry",
  "prepared horseradish": "pantry",
  "prepared mustard": "pantry",
  "preserved lemon peel": "produce",
  "pumpkin pie spice": "spices",
  "pumpkin puree": "produce",
  "pure vanilla extract": "pantry",
  "quick cooking oat": "bulk",
  "quick oat": "bulk",
  "rabbit": "protein",
  "raisin": "produce",
  "raspberry": "produce",
  "raspberry jam": "pantry",
  "raw honey": "pantry",
  "red bell pepper": "produce",
  "red currant": "produce",
  "red currant jelly": "pantry",
  "red food coloring": "pantry",
  "red lentil": "bulk",
  "red onion": "produce",
  "red pepper": "spices",
  "red pepper flake": "spices",
  "red potato": "produce",
  "red wine vinegar": "pantry",
  "rhubarb": "produce",
  "rice": "bulk",
  "rice vinegar": "pantry",
  "ricotta cheese": "dairy",
  "ripe banana": "produce",
  "ritz cracker": "bulk",
  "roasted salted pistachio": "bulk",
  "rolled oat": "bulk",
  "romano cheese": "dairy",
  "rosemary": "spices",
  "rosemary powder": "spices",
  "rubbed sage": "spices",
  "saffron": "spices",
  "sage leaf": "produce",
  "salmon fillet": "protein",
  "salsa": "pantry",
  "salt": "spices",
  "salted butter": "dairy",
  "sauerkraut": "produce",
  "scallion": "produce",
  "sea salt": "spices",
  "seasoned salt": "spices",
  "semisweet chocolate": "pantry",
  "semisweet chocolate chip": "pantry",
  "sesame oil": "pantry",
  "sesame seed": "bulk",
  "shallot": "produce",
  "sharp cheddar cheese": "dairy",
  "shortening": "pantry",
  "sliced almond": "bulk",
  "smoked paprika": "spices",
  "sour cream": "dairy",
  "soy sauce": "pantry",
  "spinach": "produce",
  "spring onion": "produce",
  "star anise": "spices",
  "steak sauce": "pantry",
  "strawberry": "produce",
  "sugar": "pantry",
  "sweet green pepper": "produce",
  "sweet onion": "produce",
  "sweet paprika": "spices",
  "sweet potato": "produce",
  "sweet red pepper": "produce",
  "sweetened condensed milk": "dairy",
  "table salt": "spices",
  "tart apple": "produce",
  "thai fish sauce": "pantry",
  "toasted sesame oil": "pantry",
  "tomato": "produce",
  "tomato paste": "pantry",
  "tomato sauce": "pantry",
  "tortilla chip": "pantry",
  "turmeric": "spices",
  "turmeric powder": "spices",
  "unsalted butter": "dairy",
  "unsweetened chocolate": "pantry",
  "unsweetened cocoa powder": "pantry",
  "vanilla": "pantry",
  "vanilla bean": "pantry",
  "vanilla extract": "pantry",
  "vegetable broth": "pantry",
  "vegetable oil": "pantry",
  "vinegar": "pantry",
  "walnut": "bulk",
  "walnut half": "bulk",
  "warm milk": "dairy",
  "whipped cream": "dairy",
  "whipping cream": "dairy",
  "white bean": "bulk",
  "white miso paste": "pantry",
  "white onion": "produce",
  "white pepper": "spices",
  "white rice": "bulk",
  "white sesame seed": "bulk",
  "white sugar": "pantry",
  "white vinegar": "pantry",
  "white wine": "pantry",
  "whole allspice": "spices",
  "whole chicken": "protein",
  "whole clove": "spices",
  "whole milk": "dairy",
  "whole mixed pickling spice": "spices",
  "wild rice": "bulk",
  "wine": "pantry",
  "wine vinegar": "pantry",
  "worcestershire sauce": "pantry",
  "yeast": "pantry",
  "yellow cake mix": "pantry",
  "yellow cornmeal": "pantry",
  "yellow onion": "produce",
  "yogurt": "dairy",
  "yukon gold potato": "produce",
};
